module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-4"
  }, [_c('v-card', {
    staticClass: "elevation-1 mb-4 pr-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("KPI por tipo de ticket")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Seleccione un tipo de ticket valido")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.tipos,
      "disabled": _vm.isLoading,
      "item-text": "label",
      "item-value": "value",
      "label": "Tipo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.changeTipo()
      }
    },
    model: {
      value: (_vm.tipoTicket),
      callback: function($$v) {
        _vm.tipoTicket = $$v
      },
      expression: "tipoTicket"
    }
  })], 1)])]), (_vm.isReadyCharts) ? _c('card-tickets-por-meses', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-pendientes-por-asesor', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-por-estado', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts) ? _c('card-tickets-cerrados-horas', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e(), (_vm.isReadyCharts && _vm.tipoTicket !== 'solicitud de insumo') ? _c('card-tickets-recall', {
    staticClass: "mb-6",
    attrs: {
      "tipo": _vm.tipoTicket,
      "tipo-area": _vm.tipoTicket === 'garantia' ? 'taller' : ''
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd6f4c4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_welcome_dispatcher.vue
// module id = 482
// module chunks = 1